import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { CustomRouter } from 'src/admin-front/ajs-upgraded-providers';

@Component({
  selector: 'app-alcmeon-ai',
  templateUrl: './alcmeon-ai.component.html',
  styleUrls: ['./alcmeon-ai.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AlcmeonAiComponent implements OnInit {
  selectedTab: number;

  // this shity hack is because when switching tab, the component in the destination tab is initied before the current tab is destroyed, even with animation = 0ms, so we need to force destroy component here, because otherwise 💥,
  // because SearchBarService has only one shared instance, it should be multi instance
  showTabContent = true;

  // keep this array synchro with states
  parentState = 'auth.alcmeon.fuse.parameters.alcmeon-ai';
  states = [`${this.parentState}.agents`, `${this.parentState}.knowledge-documents`, `${this.parentState}.setup`];

  constructor(private customRouter: CustomRouter) {}

  ngOnInit(): void {
    this.selectedTab = this.customRouter.current.data.selectedTab;
  }

  selectedIndexChange(event: number) {
    this.showTabContent = false;

    // change state (and so the url), without reloading
    this.customRouter.go(this.states[event], {}, { location: 'replace', notify: false });
  }

  animationDone() {
    this.showTabContent = true;
  }
}
